import { FormattedMessage, useIntl } from 'react-intl';
import { useEffect, useRef } from 'react';
import { USER } from '../../Hook/user';
import { cards } from '../CardList/cardsIcons';
import { PLATFORM } from '../../Hook/platform';
import { registerShift4ComponentGroup, unregisterShift4ComponentGroup } from '../utils';
import cardsIMG from "./creditcards2.png";
function CardForm({ setNewCard, newCard }: any) {
    const intl = useIntl();
    const componentGroupRef = useRef<any>(null);

    useEffect(() => {
        if(!PLATFORM.paymentprocessor) {
            PLATFORM.paymentprocessor = (window as any).Shift4(PLATFORM.platform?.securionpay_public_key);
        }
        if (newCard && PLATFORM.paymentprocessor) {
            const shift4 = PLATFORM.paymentprocessor as any;
            console.log(shift4)
            componentGroupRef.current = shift4.createComponentGroup({
                style: {
                    base: {
                        color: "#ffffff"
                    },
                    invalid: {
                        color: "#ff0000"
                    }
                }
            }).automount("#securionpay-form");
            
            // Register the component group in utils
            registerShift4ComponentGroup(componentGroupRef.current);
        }

        // Cleanup function to unregister on unmount
        return () => {
            if (componentGroupRef.current) {
                unregisterShift4ComponentGroup();
                componentGroupRef.current = null;
            }
        };
    }, [newCard]);

    if (newCard) {
        return (
            <div id="securionpay-form" className='flex flex-col gap-4 text-white'>
                <img className="h-8 m-auto" src={cardsIMG} alt="" />
                <div>
                    <label className="block text-sm font-medium mb-1">{intl.formatMessage({ id: "payment__card_owner_name" })}</label>
                    <input placeholder={intl.formatMessage({ id: "payment__card_owner_name" })} id="cardholderName" className="form-control px-2 py-2 border-gray-300 border rounded-md appearance-none" type="text"></input>
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1">{intl.formatMessage({ id: "payment__card_number" })}</label>
                    <div data-shift4="number" className="w-full interact p-2 border border-gray-300 rounded-md"></div>
                </div>
                <div className='flex gap-4'>
                    <div className="flex-1">
                        <label className="block text-sm font-medium mb-1">{intl.formatMessage({ id: "payment__expiration" })}</label>
                        <div data-shift4="expiry" className="w-full interact p-2 border border-gray-300 rounded-md"></div>
                    </div>
                    <div className="flex-1">
                        <label className="block text-sm font-medium mb-1">CVC</label>
                        <div data-shift4="cvc" className="w-full interact p-2 border border-gray-300 rounded-md"></div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div onClick={() => setNewCard(true)} className="p-4 cursor-pointer border border-border rounded-xl items-center flex item-center gap-2">
            <div className='w-8 [&>*]:w-full' dangerouslySetInnerHTML={{ __html: cards.CB }}></div>
            <div><FormattedMessage id={USER.cards.length === 0 ? "underage__add_card" : "payment__new_card_infos"} /></div>
        </div>
    )
}

export default CardForm